import { create } from "zustand";

interface IProductsInOrderState {
    areRequiredNPMInputsFilled: Map<number, boolean>;
    setAreRequiredNPMInputsFilled: (areRequiredNPMInputsFilled: number, isFilled: boolean) => void;
}

const useProductsInOrderState = create<IProductsInOrderState>((set) => ({
    areRequiredNPMInputsFilled: new Map(),
    setAreRequiredNPMInputsFilled: (areRequiredNPMInputsFilled, isFilled) => set((state) => { 
        const newState = new Map(state.areRequiredNPMInputsFilled);
        newState.set(areRequiredNPMInputsFilled, isFilled);
        return { areRequiredNPMInputsFilled: newState };
     }),
}));

export default useProductsInOrderState;